(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('SignUpExceptionDialogController', SignUpExceptionDialogController);

    function SignUpExceptionDialogController($mdDialog, $translate) {

        const vm = this;

        vm.dialogId = 'createExceptionDialog';
        vm.title = $translate.instant('Apply for an exception');
        vm.body = $translate.instant('Please provide a reason for the exception and then login with LinkedIn to apply.');
        vm.ariaLabel = $translate.instant('Reason');
        vm.label = $translate.instant('Reason');
        vm.formId = 'exceptionForm';
        vm.required = true;
        vm.inputName = 'reason';
        vm.okText = $translate.instant('Sign In with LinkedIn');
        vm.researcher = false;

        vm.hide = $mdDialog.hide;
        vm.cancel = $mdDialog.cancel;

        vm.securityResearcher = function () {

            vm.title = $translate.instant('Sign up as a security researcher');
            vm.body = $translate.instant('You can sign up to Salesflare as a security researcher with your @wearehackerone.com or @bugcrowdninja.com.');
            vm.researcher = true;

            // $window.open('https://www.salesflare.com/security', '_blank');
        };

        vm.validateEmailDomain = () => {

            if (!vm.researcher) {
                return;
            }

            const email = vm.model.toLowerCase();
            const domain = email.split('@')[1];

            if (domain === 'wearehackerone.com' || domain === 'bugcrowdninja.com') {
                vm[vm.formId].email.$setValidity('securityResearcherEmail', true);
            }
            else {
                vm[vm.formId].email.$setValidity('securityResearcherEmail', false);
            }
        };

        vm.signUpLinkedIn = function () {

            if (!vm[vm.formId].$valid) {
                return;
            }

            // Open the popup synchronously while we are still inside the user's click handler, otherwise Safari
            // blocks it as a non-user-initiated popup. We hand the pending popup promise back to the controller.
            const popupPromise = vm.openLinkedInPopUp(vm.model);

            return vm.hide({ popupPromise, type: 'linkedin' });
        };

        vm.signupResearcher = function () {

            if (!vm[vm.formId].$valid) {
                return;
            }

            return vm.hide({ email: vm.model, type: 'security' });
        };
    }
})();
